// src/components/EditarRecomendacionesHRA.jsx
import React, { useEffect, useState } from "react";
import recommendationsApi from "../../api/recommendationsApi";
import styles from "./EditarRecomendacionesHRA.module.css";

const sections = [
  "overall",
  "nutrition",
  "work",
  "metabolic",
  "activity",
  "lifestyle"
];

export default function EditarRecomendacionesHRA() {
  const [recomendaciones, setRecomendaciones] = useState({});
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(null);

  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true);
      const temp = {};
      for (const section of sections) {
        try {
          const data = await recommendationsApi.getAllBySection(section);
          temp[section] = data;
        } catch (err) {
          temp[section] = [];
        }
      }
      setRecomendaciones(temp);
      setLoading(false);
    };

    fetchAll();
  }, []);

  const handleChange = (section, index, newText) => {
    const updated = { ...recomendaciones };
    updated[section][index].text = newText;
    setRecomendaciones(updated);
  };

  const handleUpdate = async (id, section, index) => {
    setUpdating(id);
    try {
      const newText = recomendaciones[section][index].text;
      await recommendationsApi.updateRecommendationById(id, newText);
      alert("Recomendación actualizada");
    } catch (err) {
      alert("Error al actualizar");
    } finally {
      setUpdating(null);
    }
  };

  if (loading) return <p>Cargando recomendaciones...</p>;

  return (
    <div className={styles.container}>
      {sections.map((section) => (
        <div key={section} className={styles.sectionBlock}>
          <h2 className={styles.sectionTitle}>{section.toUpperCase()}</h2>
          {recomendaciones[section]?.map((rec, index) => {
            const variables = [...rec.text.matchAll(/\{\{(.*?)\}\}/g)].map((m) => m[0]);

            return (
              <div key={rec._id} className={styles.recommendationCard}>
                <p className={styles.levelLabel}>Nivel de riesgo: {rec.riskLevel}</p>

                <textarea
                  value={rec.text}
                  onChange={(e) => handleChange(section, index, e.target.value)}
                  className={styles.textArea}
                  style={{ height: "auto", overflow: "hidden" }}
                  ref={(el) => {
                    if (el) {
                      el.style.height = "auto";
                      el.style.height = el.scrollHeight + "px";
                    }
                  }}
                />

                {variables.length > 0 && (
                  <p className={styles.warning}>
                    ⚠️ Este texto contiene variables del sistema como{" "}
                    <code>{variables.join(", ")}</code>. No las elimines ni modifiques su formato.
                  </p>
                )}

                <button
                  onClick={() => handleUpdate(rec._id, section, index)}
                  disabled={updating === rec._id}
                  className={styles.updateButton}
                >
                  {updating === rec._id ? "Actualizando..." : "Actualizar"}
                </button>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}
